import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/despesas-reembolsaveis/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const store = async ({ empresa_cnpj, body }) => {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
};

export const show = async ({ empresa_cnpj, id, include }) => {
  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}&include=empresas${
      include ? `,${include}` : ""
    }`,
    "GET",
    headers
  );
};

export const update = async ({ empresa_cnpj, id, body }) => {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
};

export const destroy = async ({ empresa_cnpj, id, usuario_id }) => {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}&usuario_id=${usuario_id}`,
    "DELETE",
    headers
  );
};

export const searchExpenseByCompany = async ({ companyId, empresa_cnpj }) => {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "GET", headers, {
    empresa_id: companyId,
  });
};
